import { useMemo } from 'react';
import { ncFileStatuses } from '@helpers';
import i18n from 'i18n-js';
import { Machine } from '@interfaces/machines';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';

const useManageAdditionalLinkInfo = () => {
  const selectedMachine: Machine = useSelector(selectSelectedItem);
  const partInfo = selectedMachine?.machineStatus?.partDetails;
  const ncFileStatus = selectedMachine?.machineStatus?.ncFileStatus;

  const { description, drawing, revision, position, partName } = partInfo || {};

  const drawingPositionRevision = [drawing, position, revision];
  const filteredDPR = drawingPositionRevision.filter((value) => !!value);
  const isDPRExist = filteredDPR.length > 0;

  const shouldDisplayPartNameAndDPR = ![ncFileStatuses.Ignored, ncFileStatuses.Unknown, ncFileStatuses.Change, ncFileStatuses.Setup].includes(ncFileStatus);

  const additionalLinkText: string = useMemo(() => {
    if (ncFileStatus === ncFileStatuses.Ignored) {
      return i18n.t('Production time is excluded from reporting.');
    }

    if (ncFileStatus === ncFileStatuses.Unknown) {
      return i18n.t('Is this NC File for production or should it be ignored?');
    }

    if (ncFileStatus === ncFileStatuses.Change) {
      return i18n.t('This program runs between parts, e.g. tool change, fixture swap, or pallet rotation. Production time counts as changeover.');
    }

    if (ncFileStatus === ncFileStatuses.Setup) {
      return i18n.t('This program prepares the machine, e.g. tool measurement, zero-point calibration, or fixture probing. Production time counts as setup.');
    }

    return description || '';
  }, [ncFileStatus, description]);

  return { additionalLinkText, partName, filteredDPR, isDPRExist, shouldDisplayPartNameAndDPR };
};

export { useManageAdditionalLinkInfo };
